module.exports = __webpack_public_path__ + "static/media/SM_Cover@2x.5e9eb1f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/SM_Cover@2x.jpg
// module id = 162
// module chunks = 0